/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Metrics_Filename_LabelInputs */

const en_speakers_metrics_filename_label = /** @type {(inputs: Speakers_Metrics_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filename`)
};

const fr_speakers_metrics_filename_label = /** @type {(inputs: Speakers_Metrics_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filename`)
};

const de_speakers_metrics_filename_label = /** @type {(inputs: Speakers_Metrics_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filename`)
};

const it_speakers_metrics_filename_label = /** @type {(inputs: Speakers_Metrics_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filename`)
};

const ru_speakers_metrics_filename_label = /** @type {(inputs: Speakers_Metrics_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filename`)
};

const es_speakers_metrics_filename_label = /** @type {(inputs: Speakers_Metrics_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filename`)
};

const zh_cn2_speakers_metrics_filename_label = /** @type {(inputs: Speakers_Metrics_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filename`)
};

const ja_speakers_metrics_filename_label = /** @type {(inputs: Speakers_Metrics_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filename`)
};

const hi_speakers_metrics_filename_label = /** @type {(inputs: Speakers_Metrics_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filename`)
};

const pt_pt2_speakers_metrics_filename_label = /** @type {(inputs: Speakers_Metrics_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filename`)
};

/**
* | output |
* | --- |
* | "Filename" |
*
* @param {Speakers_Metrics_Filename_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_metrics_filename_label = /** @type {((inputs?: Speakers_Metrics_Filename_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Metrics_Filename_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_metrics_filename_label(inputs)
	if (locale === "de") return de_speakers_metrics_filename_label(inputs)
	if (locale === "it") return it_speakers_metrics_filename_label(inputs)
	if (locale === "ru") return ru_speakers_metrics_filename_label(inputs)
	if (locale === "es") return es_speakers_metrics_filename_label(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_metrics_filename_label(inputs)
	if (locale === "ja") return ja_speakers_metrics_filename_label(inputs)
	if (locale === "hi") return hi_speakers_metrics_filename_label(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_metrics_filename_label(inputs)
	return en_speakers_metrics_filename_label(inputs)
});